module.exports = __webpack_public_path__ + "img/00_logo_text_white.8d055815.svg";